import { Lottie as LottieCF, LottieProps as LottiePropsCF } from '@bcp-nextgen-dx-component-factory/design-system';

export interface LottieProps extends Omit<LottiePropsCF, 'width' | 'height'> {
	width?: string;
	height?: string;
}

export const Lottie = ({ width = '100%', height = '100%', styles, ...props }: LottieProps) => (
	<LottieCF width={width} height={height} styles={{ display: 'flex', ...styles }} {...props} />
);
